import { TicketClassCategory } from '../../constants';
import { Ticket } from '../../models/tickets';
import { CheckoutState } from '../../state';
import { getTicketsById } from './pureSelectors';

export const getHasAddonsTicketsWithMoreThanOneVariant = (
    state: CheckoutState,
) =>
    Object.values<Ticket>(getTicketsById(state)).some(
        ({ category, variants }) =>
            category === TicketClassCategory.addOn && variants?.length > 1,
    );
